import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31aff0d7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31aff0d7')) {
      api.createRecord('31aff0d7', component.options)
    } else {
      api.reload('31aff0d7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31aff0d7", function () {
      api.rerender('31aff0d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/order/components/EditTags/index.vue"
export default component.exports